import React from 'react';
import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';
import { Paragraph, ParagraphProps } from '../Paragraph';

const StyledBoldParagraph = styled(Paragraph)`
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.dStyles.elements.boldParagraph,
    )}
  ${({ theme }) =>
    renderStyledElementStyles(
      theme,
      theme.module.vStyles.elements.boldParagraph,
    )}
`;

export const BoldParagraph = ({ text }: ParagraphProps) => {
  return <StyledBoldParagraph text={text} />;
};
